import { render, staticRenderFns } from "./expense_payment_bank.vue?vue&type=template&id=10382a3c&scoped=true"
import script from "./expense_payment_bank.vue?vue&type=script&lang=js"
export * from "./expense_payment_bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10382a3c",
  null
  
)

export default component.exports